import { DevicePid } from '@/define/define'

export interface square {
  x: number
  y: number
  w: number
  h: number
}

const initSquareValue = (): square => {
  return { w: 0, h: 0, x: 0, y: 0 }
}

export const deviceSquareMap: Map<DevicePid, square> = new Map()
deviceSquareMap.set(DevicePid.IROKAl87, { w: 41.6, h: 41.6, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKAl87Pro, { w: 41.6, h: 41.6, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKAl87Rgb, { w: 41.6, h: 41.6, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKHe2, initSquareValue())
deviceSquareMap.set(DevicePid.IROKFe75Pro, { w: 36.5, h: 36.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKFe98Pro, { w: 36.5, h: 36.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKMg87, { w: 41.6, h: 41.6, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKQMKLi75, { w: 36.5, h: 36.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IYXTp87, { w: 40.5, h: 40.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IYXMt87, { w: 36.5, h: 36.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IYXOp75, { w: 36.5, h: 36.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IYXMu68, { w: 38, h: 38, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKNd75, { w: 44.5, h: 44.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKNA87, { w: 39.5, h: 39.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKMG75V2C12, { w: 39.5, h: 39.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.IROKNd63, { w: 39.5, h: 39.5, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.CarotmasMars68, { w: 36.5, h: 36.5, x: 2, y: 2 })

deviceSquareMap.set(DevicePid.IYXPolar75, { w: 36.5, h: 36.5, x: 2, y: 2 })

deviceSquareMap.set(DevicePid.CarotmasMer68, { w: 41, h: 41, x: 2, y: 2 })
deviceSquareMap.set(DevicePid.CarotmasMer68Lite, { w: 39.5, h: 39.5, x: 2, y: 2 })

export let getDeviceKeySquare = (pid: DevicePid): square => {
  let square = initSquareValue()
  let pidSquare = deviceSquareMap.get(pid)
  if (pidSquare != undefined) {
    square = pidSquare
  }
  return square
}
